import I18n from "common/i18n";
import { Layout } from "features/creator/tutorial/top/stages/Layout";
import { Title } from "../Title";

const Step = (props: { back: () => void; next: () => void; close: () => void }) => {
  const { next, close } = props;

  return (
    <Layout next={next} close={close}>
      <Title activeStep={13} />

      <div className="flex-col-el items-start justify-center w-[312px]">
        <p className="text-body text-textcolor-black text-[22px] whitespace-pre">
          {I18n.locale === "ja"
            ? "まえのがめんに\nもどってきました！"
            : "前の画面に\n戻ってきました！"}
        </p>
      </div>
    </Layout>
  );
};

export default Step;
